// extracted by mini-css-extract-plugin
export var button = "_ar-0";
export var icon = "_ar-1";